export default __webpack_public_path__ + "static/media/class_school.5ec46571.png";